module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/switch-checkbox/switch-checkbox.component.scss
// module id = ./src/app/features/pretty-check/switch-checkbox/switch-checkbox.component.scss
// module chunks = main